import SideTabs from "./SideTabs";

export default SideTabs